import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  flex-direction: column;
  gap: ${({ theme }) => theme.tokens.size.sm}px;
`;

export const ErrorContainer = styled.div`
  margin-top: ${({ theme }) => theme.tokens.size.lg}px;
`;

export const AccessDeniedContainer = styled.div`
  margin-top: ${({ theme }) => theme.tokens.size.lg}px;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  text-align: center;
  padding: ${({ theme }) => theme.tokens.size.xl}px;
  border-radius: ${({ theme }) => theme.tokens.border.radius.md}px;
  background-color: ${({ theme }) => theme.tokens.color.surface.primary};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const AccessDeniedIllustration = styled.img`
  width: 100%;
  max-width: 240px;
  height: auto;
  margin: 0 auto ${({ theme }) => theme.tokens.size.lg}px;
  display: block;
  object-fit: contain;
`;

export const AccessDeniedAlert = styled.div`
  margin-bottom: ${({ theme }) => theme.tokens.size.lg}px;
`;

export const AccessDeniedTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.tokens.size.sm}px;
`;

export const AccessDeniedDescription = styled.div`
  color: ${({ theme }) => theme.tokens.color.text.secondary};
`;

export const AccessDeniedDescriptionLine = styled.div`
  margin-top: ${({ theme }) => theme.tokens.size.sm}px;
`;

export const AccessDeniedEmailLink = styled.a`
  color: ${({ theme }) => theme.tokens.color.text.primary};
  text-decoration: underline;
  &:hover {
    opacity: 0.8;
  }
`;

export const ErrorAlert = styled.div`
  padding: ${({ theme }) => theme.tokens.padding.lg}px;
  border-radius: ${({ theme }) => theme.tokens.border.radius.sm}px;
  background-color: ${({ theme }) => theme.tokens.color.surface.errorSoft};
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  color: ${({ theme }) => theme.tokens.color.text.primary};
`;
